module.exports = __webpack_public_path__ + "img/automated-construction.6fc86b30.png";